export default __webpack_public_path__ + "static/media/thumb_riverwalk_trail.26f919a4.jpg";